import api from '../../api/_echange'


const state = () => ({
    echanges: [],
})

// getters
const getters = {
    echanges: (state) => {
        return state.echanges
    },


}

// actions
const actions = {
    /**
     * Transferts d'un stock (reçus et envoyés)
     */
    getEchanges({commit}, id) {
        return api.getEchange(id).then(
            response => {
                commit('SET_ECHANGES', Array.isArray(response) ? response : [])
                return response
            }
        )
    },

    /**
     * Enregistre un transfert et renvoie la réponse du serveur ({ echange, erreur }) :
     * `erreur` compte les lignes refusées (quantité de départ insuffisante).
     */
    async saveEchange(context, data) {
        return api.saveEchange(data).then(
            response => {
                return response

            }
        )
    },

    getHospitalServices() {
        return api.hospitalServices()
    },

    saveServiceDispatch(context, data) {
        return api.saveServiceDispatch(data)
    },


}

// mutations
const mutations = {

    SET_ECHANGES(state,echanges) {
        state.echanges = echanges
    },
}

export default {
  state,
  getters,
  actions,
  mutations
}
